import React from 'react';
import './Loader.css'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartbeat } from '@fortawesome/free-solid-svg-icons'; // Use a relevant physiotherapy icon

const Loader = () => {
    return (
        <div className="loader">
            <div className="spinner"></div>
            <FontAwesomeIcon icon={faHeartbeat} size="2x" className="loading-icon" /> {/* Heartbeat icon */}
            <div className="loading-text">Loading, please wait...</div> {/* Loading message */}
        </div>
    );
};

export default Loader;
